'use strict';

var Heading = require('./src/Heading.js');
var Link = require('./src/Link.js');
var ListItem = require('./src/ListItem.js');
var OrderedList = require('./src/OrderedList.js');
var Text = require('./src/Text.js');
var UnorderedList = require('./src/UnorderedList.js');

// Множественный дефолтный импорт внутри entrypoint приводит к поломке экспорта типов
// TODO: не собираются стили всей типографики

exports.Heading = Heading.Heading;
exports.Link = Link.Link;
exports.Li = ListItem.ListItem;
exports.ListItem = ListItem.ListItem;
exports.Ol = OrderedList.OrderedList;
exports.OrderedList = OrderedList.OrderedList;
exports.Text = Text.Text;
exports.Ul = UnorderedList.UnorderedList;
exports.UnorderedList = UnorderedList.UnorderedList;
//# sourceMappingURL=index.js.map
